import React from 'react'

const EmergencyContactList = ({ item, individualCheck, individualLevelHandler, parentObj, isNotifFormEnabled }) => {
    return (
        <div className="dataAccessListItem">
            <input type="checkbox"
                checked={item.contactSelected}
                onChange={() => individualLevelHandler(parentObj, item.contactId)}
                disabled={!isNotifFormEnabled}
            />
            <p className="AllTextwithValue"
            //onClick={() => individualLevelHandler(parentObj, item.contactId)}
            >Level {item.contactId}</p>
        </div>
    )
}

export default EmergencyContactList